// The session list's persisted column-layout keys.
//
// They live on the INERT door rather than beside the atoms they name, because
// their widest consumer is `src/utils/auth/logoutStorage.ts` — a module the app
// shell reaches through `authModel`, so a module-scope import of the `.` UI door
// for three string constants makes the session UI barrel (and every design-system
// door behind it) eager for everything downstream of sign-out. A storage key is
// a frozen user-data contract and needs nothing but itself.
//
// One identity, ONE declaration: this is the only declaration site. The atoms
// built over these keys read them from here.

/** localStorage key for the session list's per-scope column hide/show choices
 *  (full-list mode). Namespaced by user id (see `createUserScopedStorageAtom`)
 *  so a shared workstation can't leak one clinician's column layout to the
 *  next; survives reload and re-login (the per-user id that resolves this key
 *  is restored on sign-in, so the same user gets their layout back). */
export const SESSION_LIST_COLUMN_VISIBILITY_STORAGE_KEY = 'sessionListColumnVisibility';

/** localStorage key for the split-view column hide/show choices. A bucket kept
 *  separate from the full-list one so each layout remembers its own selection
 *  independently (same per-scope, boolean shape). */
export const SESSION_LIST_SPLIT_COLUMN_VISIBILITY_STORAGE_KEY =
  'sessionListSplitColumnVisibility';

/** localStorage key for the split-view *selection order* of subtitle-able
 *  columns — the sequence the user enabled them in, which drives the split-view
 *  subtitle lane stacking (see `ui/session-list/subtitle-layout.ts`). Only the
 *  split layout stacks subtitles, so there's no full-list counterpart. */
export const SESSION_LIST_SPLIT_COLUMN_ORDER_STORAGE_KEY = 'sessionListSplitColumnOrder';
